export default __webpack_public_path__ + "static/media/banner.350156c7.png";